import { useRouteMatch } from 'react-router-dom'

import DashboardHeader from './components/DashboardHeader'
import DataSearch from './components/DataSearch'
import Jaqi from './components/Jaqi'
import { MetabaseAccountOverview } from './components/MetabaseAccountOverview'
import { MetabaseCampaignOverview } from './components/MetabaseCampaignOverview'
import { PAGES, PATH } from './interfaces'

export default function Dashboard() {
  const { path } = useRouteMatch()
  const selectedPage = PAGES.find((page) => page.path === path)

  const isAccountView =
    selectedPage?.path === PATH.MetabaseAccount ||
    selectedPage?.path === PATH.MetabaseAccountPersonalise

  const isCampaignView =
    selectedPage?.path === PATH.MetabaseCampaign ||
    selectedPage?.path === PATH.MetabaseCampaignPersonalise

  return (
    <>
      <DashboardHeader />
      {isAccountView && <MetabaseAccountOverview />}
      {isCampaignView && <MetabaseCampaignOverview />}
      {selectedPage?.path === PATH.DataSearch && <DataSearch />}
      {selectedPage?.path === PATH.JaqiAi && <Jaqi />}
    </>
  )
}
